import { render, staticRenderFns } from "./AuthenticationCard.vue?vue&type=template&id=f8b3e13c&"
import script from "./AuthenticationCard.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports